import { render } from "./MarketInfoModal.vue?vue&type=template&id=eaa87852&scoped=true"
import script from "./MarketInfoModal.vue?vue&type=script&lang=js"
export * from "./MarketInfoModal.vue?vue&type=script&lang=js"

import "./MarketInfoModal.vue?vue&type=style&index=0&id=eaa87852&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaa87852"]])

export default __exports__